module.exports = __webpack_public_path__ + "assets/img/Preview_tit.505a73dd.png";